import styled from 'styled-components'

export const StyledPublicShowcase = styled.div`
    display: grid;
    grid-template-rows: auto 1fr;
    overflow: auto;
`
